var scope_0 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/22737cfe2a4246b0d9748aeb70403f28.js').default;
var scope_1 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/34a64ce6c32a6711ceea5d1f1cabd593.js').default;
var scope_2 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/41a4899d2c6527397f65c76487b45e58.js').default;
var scope_3 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/42edbf5bd477d3be07b5a31897791dab.js').default;
var scope_4 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/566c36830417ac0cd98bcc623c82900b.js').default;
var scope_5 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/57369e0b148634adac391a8cbf1d9cf9.js').default;
var scope_6 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5a0d4ae65a8ea6fcffc95a91c1d78605.js').default;
var scope_7 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7a6b2a4c690657023def7dd477cfead4.js').default;
var scope_8 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b50e6c60bb48a2e0a47e21c5b8b9373a.js').default;
var scope_9 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b8dde10442fb659b70ba20386a58e127.js').default;
var scope_10 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bc07be1b0caa327f2266159ebc8e90a5.js').default;
var scope_11 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c5af54b45d60a2c831412cfacab73709.js').default;
var scope_12 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d9c88f99c2bf4ce37400c8f58762fb11.js').default;
var scope_13 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e3f5713a3258ae661057e2ba2253dee2.js').default;
var scope_14 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e7681016a89825b3ec98924486ad6a38.js').default;
var scope_15 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_16 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f4efce9c9fca55ae12b088f9d5c053d1.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16 )
    